import { render, staticRenderFns } from "./file-drop.vue?vue&type=template&id=8cb34174&"
import script from "./file-drop.vue?vue&type=script&lang=js&"
export * from "./file-drop.vue?vue&type=script&lang=js&"
import style0 from "./file-drop.vue?vue&type=style&index=0&id=8cb34174&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports